"use client";

import { useMemo } from "react";

import { buildProjectCover } from "@/app/(application)/(ttv)/ttv/components/ttvApplication/controls/modals/projectCover/buildProjectCover";
import {
  COVER_CENTER,
  COVER_VIEW_BOX_SIZE,
} from "@/app/(application)/(ttv)/ttv/components/ttvApplication/controls/modals/projectCover/constants";
import { cn } from "@/utils/cn";

// The light a cover throws on the card it sits on: one disc in the cover's main colour, softened and faded by the caller's classes. An SVG rather than a tinted div because the colour is computed per cover, and a fill attribute carries that without an inline style.
export function ProjectCoverGlow({
  seedText,
  className,
}: {
  seedText: string;
  className: string;
}) {
  const cover = useMemo(() => buildProjectCover(seedText), [seedText]);

  return (
    <svg
      aria-hidden
      viewBox={`0 0 ${COVER_VIEW_BOX_SIZE} ${COVER_VIEW_BOX_SIZE}`}
      className={cn("pointer-events-none block", className)}
    >
      <circle
        cx={COVER_CENTER}
        cy={COVER_CENTER}
        r={COVER_CENTER}
        fill={cover.glowColor}
      />
    </svg>
  );
}
